import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAgentSummaryApi } from '../../../utils/apis';
import CallSummaryContentSkeleton from '../Skeletons/CallSummaryContentSkeleton';
import { Box, Typography } from '@mui/material';
import NoDataFallback from '../../common/NoDataFallback';

const CallSummary: React.FC<{
  selectedAssistantId?: string;
  chatId?: string;
}> = ({ chatId }) => {
  const { data: agentSummaryData, isLoading: isAgentSummaryLoading } = useQuery(
    {
      queryKey: ['get-agent-summary', chatId],
      queryFn: () => getAgentSummaryApi(chatId || ''),
      enabled: !!chatId,
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 30,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: 0,
    }
  );

  if (isAgentSummaryLoading) {
    return <CallSummaryContentSkeleton />;
  }

  if (!agentSummaryData?.data?.data?.summary) {
    return (
      <Box sx={{ height: '100%', width: '100%' }}>
        <NoDataFallback
          message="No Call Summary Available"
          description="The call summary data is not available at the moment. Please try refreshing or check back later."
        />
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          width: '100%',
          bgcolor: 'background.paper',
        }}
      >
        <Box sx={{ p: 3 }}>
          <Typography
            variant="h6"
            sx={{
              fontSize: '1.125rem',
              fontWeight: 'semibold',
              color: 'primary.main',
              mb: 2,
            }}
          >
            Short Summary
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'justify',
              fontSize: '15px',
              color: 'text.secondary',
            }}
          >
            {agentSummaryData?.data?.data?.summary}
          </Typography>
        </Box>

        {/* <Box
          sx={{
            display: 'flex',
            flex: 1,
            width: '100%',
          }}
        >
          <Box
            sx={{
              width: '50%',
              p: 3,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: '1.125rem',
                fontWeight: 'semibold',
                color: 'primary.main',
                mb: 3,
              }}
            >
              Key Details
            </Typography>
            <List>
              {callAnalysisData.key_details.map((key, index) => (
                <ListItem key={index}>
                  <ListItemText
                    primary={`${index + 1}. ${key.detail}`}
                    sx={{
                      color: 'text.secondary',
                      textAlign: 'justify',
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>

          <Box sx={{ width: '50%', p: 3 }}>
            <Typography
              variant="h6"
              sx={{
                fontSize: '1.125rem',
                fontWeight: 'semibold',
                color: 'primary.main',
                mb: 3,
              }}
            >
              Behavior Analysis
            </Typography>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: 'grey.100' }}>
                    <TableCell sx={{ color: 'text.secondary' }}>Role</TableCell>
                    <TableCell sx={{ color: 'text.secondary' }}>
                      Behavior
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {callAnalysisData.behavior_analysis.map(item => (
                    <TableRow key={item._id}>
                      <TableCell sx={{ color: 'text.secondary' }}>
                        {item.role}
                      </TableCell>
                      <TableCell sx={{ color: 'text.secondary' }}>
                        {item.behavior}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box> */}
      </Box>
    </Box>
  );
};

export default CallSummary;
